import React, { useEffect } from "react";
import { useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { studyEDCDashboardGraph } from "../../../../APIServices/studyEDCDashboardGraph";
import { useParams } from "react-router";

const UpdateDynamicGraph = ({
    Show,
    Hide,
    graphData,
    getEDCDashboardGraph,
    GraphShowList,
    setStandardGraphRefresh,
}) => {
    const [graphName, setGraphName] = useState("");
    const [yAxisName, setYAxisName] = useState("");
    const [xAxisName, setXAxisName] = useState("");
    const [fieldOption, setFieldOption] = useState([]);
    const [colorOptions, setColorOptions] = useState([]);
    const [buttonLoader, setButtonLoader] = useState(false);
    let { studyId } = useParams();

    const updateEDCDashboardGraph = async () => {
        setButtonLoader(true)
        let userData = {}
        userData.id = graphData?._id
        userData.studyId = studyId
        userData.yAxisName = yAxisName
        userData.xAxisName = xAxisName
        userData.graphName = graphName
        userData.fieldOption = fieldOption
        userData.colorOptions = colorOptions
        let data = await studyEDCDashboardGraph.updateEDCDashboardGraph(userData)
        if (data?.statusCode === 200) {
            getEDCDashboardGraph()
            setStandardGraphRefresh(Math.floor(1000000000 + Math.random() * 9000000000));
            GraphShowList()
        }
        setButtonLoader(false)
    }

    const handleEDCColorChange = (e, index) => {
        const selectedColor = e.target.value;
        const updatedOptions = fieldOption.map((opt, i) =>
            i === index ? { ...opt, color: selectedColor } : opt
        );
        setFieldOption(updatedOptions);
    };

    const handleStandardColorChange = (index, value) => {
        const updated = [...colorOptions];
        updated[index].color = value;
        setColorOptions(updated);
    };

    useEffect(() => {
        if (graphData) {
            setGraphName(graphData?.graphName);
            setYAxisName(graphData?.yAxisName);
            setXAxisName(graphData?.xAxisName);
            setFieldOption(graphData?.categoryColor || []);
            setColorOptions(graphData?.colorOptions || []);
        }
    }, [graphData]);

    useEffect(() => {
        if (!Show && graphData) {
            GraphShowList()
        }
    }, [Show, graphData]);
    return (
        <>
            <Offcanvas
                show={Show}
                onHide={Hide}
                placement="end"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Update {graphData.category === "edc" ? "EDC" : "Standard"} Graph</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {graphData?.category === "edc" && fieldOption?.length > 0 &&
                        <Form.Group className="mb-1">
                            <Form.Label className="fw-bold mb-1">
                                Option Status Color{" "}
                                <abbr title="Required" className="text-danger">
                                    *
                                </abbr>
                            </Form.Label>
                            {fieldOption?.map((item, index) => (
                                <div className="hstack gap-2">
                                    <Form.Control
                                        className="mb-2 border-0 rounded-0 p-0 mt-1"
                                        style={{ width: 25, height: 13 }}
                                        type="color"
                                        value={item.color}
                                        onChange={(e) => handleEDCColorChange(e, index)}
                                    />
                                    <Form.Label className="fw-bold mb-1">
                                        {item?.option}
                                    </Form.Label>
                                </div>
                            ))}
                        </Form.Group>
                    }
                    {(graphData?.category === "standard" && graphData?.subjectDataBy === "screenStatus" && graphData?.subjectDataValue === "allStatus") &&
                        <Form.Group className="mb-1">
                            <Form.Label className="fw-bold mb-1">
                                Option Status Color{" "}
                                <abbr title="Required" className="text-danger">
                                    *
                                </abbr>
                            </Form.Label>
                            {colorOptions.map((item, idx) => (
                                <div key={idx} className="hstack gap-2">
                                    <Form.Control
                                        className="mb-2 border-0 rounded-0 p-0 mt-1"
                                        style={{ width: 25, height: 13 }}
                                        type="color"
                                        value={item.color}
                                        onChange={(e) => handleStandardColorChange(idx, e.target.value)}
                                    />
                                    <Form.Label className="fw-bold mb-1">{item.option}</Form.Label>
                                </div>
                            ))}
                        </Form.Group>
                    }
                    <div>
                        <Form.Label className="fw-bold mb-1">{"Graph Name"}</Form.Label>
                        <br />
                        <Form.Control
                            onChange={(e) => setGraphName(e.target.value)}
                            value={graphName}
                            type="text"
                            placeholder="Graph Name"
                            className="form-control inputboxborder"
                        />
                    </div>
                    {graphData.graphType === "barColumnGraph" && (
                        <>
                            <Form.Group className="mb-1">
                                <Form.Label className="fw-bold mb-1">
                                    Y-Axis Name{" "}
                                    <abbr title="Required" className="text-danger">
                                        *
                                    </abbr>
                                </Form.Label>
                                <Form.Control
                                    className="mb-2"
                                    type="text"
                                    value={yAxisName}
                                    onChange={(e) => setYAxisName(e.target.value)}
                                    placeholder="Y-Axis Name"
                                />
                            </Form.Group>
                            <Form.Group className="mb-1">
                                <Form.Label className="fw-bold mb-1">
                                    X-Axis Name{" "}
                                    <abbr title="Required" className="text-danger">
                                        *
                                    </abbr>
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    className="mb-2"
                                    value={xAxisName}
                                    onChange={(e) => setXAxisName(e.target.value)}
                                    placeholder="X-Axis Name"
                                />
                            </Form.Group>
                        </>
                    )}
                </Offcanvas.Body>
                <div className="hstack justify-content-end p-2 border-top shadow-sm bg-light">
                    <button
                        onClick={updateEDCDashboardGraph}
                        className="updateProfile"
                        disabled={graphData.graphType === "barColumnGraph" ? (!graphName || !yAxisName || !xAxisName) : !graphName}
                    >
                        {buttonLoader ? (
                            <div className="hstack gap-1">
                                <Spinner size="sm" /> Updating...
                            </div>
                        ) : (
                            "Update"
                        )}
                    </button>
                </div>
            </Offcanvas>
        </>
    );
};

export default UpdateDynamicGraph;
